package com.essntl.features.currency.ui.addcurrency

import com.essntl.core.settings.domain.model.configuration.ConfigurationCurrencyModel

sealed interface AddCurrencyEvent {
    data object GetAllCurrencies : AddCurrencyEvent
    data class SetConfigurationCurrency(val configurationCurrency: ConfigurationCurrencyModel) : AddCurrencyEvent
    data class SelectUnselectCurrency(val currencyCode: String) : AddCurrencyEvent
    data object AddCurrencies : AddCurrencyEvent
    data object ClearState : AddCurrencyEvent
}